import { getAuth } from 'firebase/auth';

function getKey() {
  const uid = getAuth().currentUser?.uid;
  return uid ? `chatHistory_${uid}` : 'chatHistory_guest';
}

export const getChatHistory = () => {
  try {
    const data = localStorage.getItem(getKey());
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const saveChatHistory = (chatHistory) => {
  try {
    localStorage.setItem(getKey(), JSON.stringify(chatHistory));
  } catch (err) {
    console.error('Error saving chat history:', err);
  }
};

export const clearChatHistory = () => {
  try {
    localStorage.removeItem(getKey());
  } catch {/* ignore */}
};
